import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { Button } from '../../Zemplin/General/Button';
import { FlexRowCenterVertical, IconImg } from '../../..';
import { __ } from 'react-i18n';
import { IconType, DsiSvgIcon as SvgIcon } from '../General/SvgIcon';
import { Link } from 'react-router';

interface Props {
  id: string,
  addToFavoriteOpen: () => void;
  hasFavourite?: boolean;
  isCompare?: boolean;
  showCompareIcon?: boolean;
  addToCompare: (id) => void;
}

function FavoriteCompare(props:Props) {
  const { id, addToFavoriteOpen, hasFavourite = true, isCompare, showCompareIcon, addToCompare} = props;

  const [iscompareP, setIsCompareP] = React.useState(isCompare); 
  const [isHoverComp, setIsHoverComp] = React.useState(false);

  const onSetIsHoverComp = e => {
    setIsHoverComp(true);
  };
  const offSetIsHoverComp = e => {
    setIsHoverComp(false);
  };

  return (
    <>
      <Wrapper>
        {showCompareIcon && (<Item title={__('Pridať do porovnania.')}>
          <StyledLink
            onMouseEnter={onSetIsHoverComp}
            onMouseLeave={offSetIsHoverComp}
            onClick={() => {
              setIsCompareP(!iscompareP);
              addToCompare(id);
            }}
          >
            <SvgIcon
              icon={IconType.compare}
              cursor={'pointer'}
              fill={isHoverComp || iscompareP ? '#000000' : '#DDDDDD'}
              title={iscompareP?`${'Odstrániť z porovnania'}`:`${__('Pridať do porovnania')}`}
            />
          </StyledLink>
        </Item> )
        }
        {hasFavourite && (
          <Item onClick={addToFavoriteOpen} title={__('Pridať do oblúbených.')}>
            <StyledIconImg
              cursor={'pointer'}
              src={'/assets/dsi/favorite.svg'}
              alt={__('Pridať do oblúbených.')}
              marginRight={false}
            />
          </Item>
        )}
      </Wrapper>
    </>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  
`;

const Item = styled(Button)`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: ${rem(8)} ${rem(16)};
  margin-right: ${rem(8)};
  height: ${rem(56)};

  &:last-child {
    margin-right: 0;
  }
  ${({ theme }) => theme.mediab.m600`
    width: 100%;
  `}
`;

const StyledIconImg = styled(IconImg)`
  max-width: ${rem(56)};
`;

const StyledLink = styled(Link)`
 
`;

export { FavoriteCompare };
